<script>
import MainMenuStudentView from '../../../shared/views/MainMenuStudentView';
import ListExploreLiveClass from '../lists/ListExploreLiveClassView';
import ListExploreLiveClassFinished from '../lists/ListExploreLiveClassFinished';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';

export default {
  name: 'ModuleExploreLiveClassView',
  components: {
    'main-menu-student-view': MainMenuStudentView,
    'list-explore-live-class-view': ListExploreLiveClass,
    'list-explore-live-class-finished-view': ListExploreLiveClassFinished,
  },
  data() {
    return {
      activeName: 'active',
    };
  },
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>

<template>
  <div>
    <main-menu-student-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <!-- Encabezado de página estilo Appmisionate -->
                <div class="stream_page_header">
                  <div class="stream_header_left">
                    <div class="stream_header_icon">
                      <i class="fas fa-broadcast-tower" />
                    </div>
                    <div class="stream_header_text">
                      <h4 class="item_title">
                        Todas las Clases en Vivo
                      </h4>
                      <p class="stream_header_subtitle">
                        Transmisiones en directo con profesores expertos y biblioteca de sesiones grabadas
                      </p>
                    </div>
                  </div>
                  <div class="stream_header_right">
                    <span class="stream_live_pill">
                      <span class="pill_dot" /> Transmisiones interactivas
                    </span>
                  </div>
                </div>

                <!-- Tabs modernizados -->
                <div class="la5lo1">
                  <el-tabs
                    v-model="activeName"
                    class="stream_tabs"
                  >
                    <el-tab-pane name="active">
                      <template #label>
                        <span class="stream_tab_label">
                          <span class="tab_live_dot" /> Activos (En Vivo)
                        </span>
                      </template>
                      <list-explore-live-class-view />
                    </el-tab-pane>
                    <el-tab-pane name="finished">
                      <template #label>
                        <span class="stream_tab_label">
                          <i class="fas fa-video" /> Finalizados (Grabaciones)
                        </span>
                      </template>
                      <list-explore-live-class-finished-view />
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
